import { Flex, Tabs } from "antd"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"
import { Title } from "ui/Typography"
import styles from "./index.module.css"
import TimeOffEntries from "./TimeOffEntries"
import PropTypes from "prop-types"
import { TIME_OFF_BE_KEYS } from "pagesV2/pro/Calendar/constants"

const ExistingTimeOffDetails = ({ form, setEditingTimeOffItem }) => {
  const { t } = useTranslation()

  const handleTabChange = () => {
    setEditingTimeOffItem(null)
    form.resetFields()
  }

  return (
    <Flex vertical gap={spacings.XL} className={styles.existingTimeOffContainer}>
      <Title level={4}>{t("calendar.schedule_time_off.existing_time_off")}</Title>
      <Tabs
        destroyInactiveTabPane={true}
        onChange={handleTabChange}
        items={[
          {
            key: TIME_OFF_BE_KEYS.weekDays,
            label: t("calendar.schedule_time_off.weekdays"),
            children: <TimeOffEntries type={TIME_OFF_BE_KEYS.weekDays} form={form} setEditingTimeOffItem={setEditingTimeOffItem} />
          },
          {
            key: TIME_OFF_BE_KEYS.dateRange,
            label: t("calendar.schedule_time_off.date_range"),
            children: <TimeOffEntries type={TIME_OFF_BE_KEYS.dateRange} form={form} setEditingTimeOffItem={setEditingTimeOffItem} />
          },
          {
            key: TIME_OFF_BE_KEYS.singleDay,
            label: t("calendar.schedule_time_off.single_day"),
            children: <TimeOffEntries type={TIME_OFF_BE_KEYS.singleDay} form={form} setEditingTimeOffItem={setEditingTimeOffItem} />
          }
        ]}
      />
    </Flex>
  )
}

ExistingTimeOffDetails.propTypes = {
  form: PropTypes.object.isRequired,
  setEditingTimeOffItem: PropTypes.func.isRequired
}

export default ExistingTimeOffDetails
